import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import PageHeader from '../components/PageHeader';
import ConfigurationWarning from '../components/common/ConfigurationWarning';

// Import the tab components
import SyncOperationsTab from '../components/tracking-sync/SyncOperationsTab';
import SettingsTab from '../components/tracking-sync/SettingsTab';
import SyncedTrackingTab from '../components/tracking-sync/SyncedTrackingTab';
import FieldMappingTab from '../components/tracking-sync/FieldMappingTab';
import ComponentSelector from '../components/tracking-sync/ComponentSelector';

export default function TrackingSync() {
  const location = useLocation();

  // Determine active tab based on the current URL
  const getActiveTabFromPath = () => {
    const path = location.pathname;
    if (path.includes('/tracking-sync/tracking')) return 1;
    if (path.includes('/tracking-sync/mapping')) return 2;
    if (path.includes('/tracking-sync/settings')) return 3;
    return 0; // Default to sync operations
  };

  const [activeTab, setActiveTab] = useState(getActiveTabFromPath());

  // Update active tab when the location changes
  useEffect(() => {
    setActiveTab(getActiveTabFromPath());
  }, [location]);

  return (
    <Box>
      <PageHeader
        title='Tracking Synchronization'
        subtitle='Sync tracking information from your ERP system to Shopify'
      />

      <ConfigurationWarning>
        <ComponentSelector />

        {/* Render the active tab content */}
        {activeTab === 0 && <SyncOperationsTab />}
        {activeTab === 1 && <SyncedTrackingTab />}
        {activeTab === 2 && <FieldMappingTab />}
        {activeTab === 3 && <SettingsTab />}
      </ConfigurationWarning>
    </Box>
  );
}
